import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditProductCategory = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Product Category'
      fields={fields}
      apiPath={`admin/product_categories/${props.params.productCategoryId}`}
      successRedirectPath='/ecommerce/product-categories'
      buildMenuItems={menuItems}
    />
  )
}

export default EditProductCategory
